import { Menu } from "../../type";
import { customAlphabet, nanoid } from "nanoid";
import { useRouteMatch } from "react-router";
import React from "react";

const menuIdGenerator = customAlphabet("abcde", 4);

const SideBar = (props: { brand: string; menu: Menu[] }) => {
	const { brand, menu } = props;

	return (
		<ul
			className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
			id="accordionSidebar"
		>
			<a
				className="sidebar-brand d-flex align-items-center justify-content-center"
				href="/"
			>
				{/* <div className="sidebar-brand-icon rotate-n-15">
					<i className="fas fa-laugh-wink"></i>
				</div> */}
				<div className="sidebar-brand-text mx-3">{brand}</div>
			</a>
			<hr className="sidebar-divider my-0" />
			<li className={`nav-item ${useCheckActive("/") && "active"}`}>
				<a className="nav-link" href="/">
					<i className="fas fa-fw fa-tachometer-alt"></i>
					<span>Trang chủ</span>
				</a>
			</li>
			<hr className="sidebar-divider" />
			{menu.map((m) => {
				return <MenuGroup key={nanoid()} menu={m} />;
			})}

			<div className="text-center d-none d-md-inline">
				<button className="rounded-circle border-0" id="sidebarToggle"></button>
			</div>
			{/* <div className="sidebar-card d-none d-lg-flex">
				<img
					className="sidebar-card-illustration mb-2"
					src="../../asset/img/undraw_rocket.svg"
					alt="..."
				/>
				<p className="text-center mb-2">
					<strong>SB Admin Pro</strong> is packed with premium features,
					components, and more!
				</p>
				<a
					className="btn btn-success btn-sm"
					href="https://startbootstrap.com/theme/sb-admin-pro"
				>
					Upgrade to Pro!
				</a>
			</div> */}
		</ul>
	);
};

const MenuGroup = (props: { menu: Menu }) => {
	const { menu } = props;
	return (
		<React.Fragment>
			<div className="sidebar-heading">{menu.text}</div>
			{menu.subMenu &&
				menu.subMenu.map((s) => <AMenu key={nanoid()} menu={s} />)}
			<hr className="sidebar-divider" />
		</React.Fragment>
	);
};

const AMenu = (props: { menu: Menu }) => {
	const { menu } = props;
	const id = menuIdGenerator();
	const aTag = menu.subMenu ? (
		<a
			className="nav-link collapsed"
			href={menu.href}
			data-toggle="collapse"
			data-target={`#${id}`}
			aria-expanded="true"
			aria-controls="collapseTwo"
		>
			<i className={`fas fa-fw ${menu.fa}`}></i>
			<span className="text-capitalize">{menu.text}</span>
		</a>
	) : (
		<a className="nav-link" href={menu.href}>
			<i className={`fas fa-fw ${menu.fa}`}></i>
			<span className="text-capitalize">{menu.text}</span>
		</a>
	);

	return (
		<li className={`nav-item ${useCheckActive(menu.href) && "active"}`}>
			{aTag}
			{menu.subMenu && (
				<div
					id={id}
					className="collapse"
					aria-labelledby="headingTwo"
					data-parent="#accordionSidebar"
				>
					<div className="bg-white py-2 collapse-inner rounded">
						{menu.subMenu.map((s) => {
							return (
								<a
									key={nanoid()}
									className="collapse-item text-capitalize"
									href={s.href}
								>
									<i className={`fas fa-fw ${s.fa} mr-1`}></i>
									{s.text}
								</a>
							);
						})}
					</div>
				</div>
			)}
		</li>
	);
};

function useCheckActive(href: string): boolean {
	const { url } = useRouteMatch();
	return firstPath(url) === firstPath(href);
}

function firstPath(path: string) {
	return path.split("/")[1];
}

export default SideBar;
